<template>
    <div class="indev-wrap">
        <div class="indev-box">
            <GlassCard id="a1-card">
                <template #title>
                  <span>Looks like this page is still in development!</span>
                </template>
                <template #content>
                    <p>
                        I'm sorry, but it looks like this page is not quite ready for the prime time just yet!
                    </p>
                    <p>
                        In the meantime, you can browse my other projects and websites.
                    </p>
                </template>
                <template #footer>
                  <div class="a1-ft">
                    <!-- <ScButton scto="a2">See More</ScButton> -->
                    <!-- <ScButton scto="a2">Contact Me</ScButton> -->
                  </div>
                </template>
              </GlassCard>
            <div id="indevbg"></div>
        </div>
    </div>
</template>

<script>
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { TAARenderPass } from 'three/addons/postprocessing/TAARenderPass.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';

import Stats from 'three/examples/jsm/libs/stats.module'
import {ref} from 'vue'

import indev_f from 'raw-loader!@/assets/shaders/indev1.frag'
import indev_v from 'raw-loader!@/assets/shaders/indev1.vert'
import indev2_f from 'raw-loader!@/assets/shaders/indev2.frag'
import indev2_v from 'raw-loader!@/assets/shaders/indev2.vert'

import GlassCard from '@/components/GlassCard.vue';
import ScButton from '@/components/ScButton.vue';

export default {
    name: 'IndevView',
    components: {
        GlassCard,
        ScButton
    },
    props: [],
    setup(props, ctx) {
        const anim = ref(true)
        return {anim}
    },
    mounted(ctx) {
        this.anim = true
        const clock = new THREE.Clock();
        var delta = 0;
        const inter_points_ww = [
            [400, 1.5],
            [1100, 4],
            [1600, 5],
            [1800, 5]
        ];

        const scene = new THREE.Scene();
        const CLOCK = new THREE.Clock(true);
        CLOCK.getDelta()
        // const stats = Stats()
        // document.body.appendChild(stats.dom)
        const domel = document.getElementById("indevbg")
        let camera = new THREE.PerspectiveCamera(90, domel.scrollWidth / domel.scrollHeight, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer({
            logarithmicDepthBuffer: true
        });
        renderer.setSize(domel.scrollWidth, domel.scrollHeight);
        domel.appendChild(renderer.domElement);
        window.hv = {
            camera: camera,
            renderer: renderer,
            scene: scene
        }
        const renderScene = new RenderPass(scene, camera);
        const uniforms = {
            time: {
                value: 1.0
            },
            tex: {
                type: "t",
                value: new THREE.TextureLoader().load(require('../assets/img/map2.png'))
            }
        }

        const blinker_mat = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: indev_v,
            fragmentShader: indev_f,
            side: THREE.DoubleSide,
            blending: THREE.AdditiveBlending,
            // combine: THREE.MixOperation
            transparent: true,
            depthFunc: THREE.NotEqualDepth
        });
        const effects_mat_1 = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: indev2_v,
            fragmentShader: indev2_f,
            side: THREE.DoubleSide,
            blending: THREE.AdditiveBlending,
            // combine: THREE.MixOperation,
            transparent: true,
            depthFunc: THREE.LessEqualDepth 
        });
        const effects_mat_2 = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: indev2_v,
            fragmentShader: indev2_f,
            side: THREE.DoubleSide,
            blending: THREE.AdditiveBlending,
            // combine: THREE.MixOperation,
            transparent: true,
            depthFunc: THREE.AlwaysDepth 
        });
        // material.alphaHash = true;
        // material.blendSrcAlpha = true;
        // material.blendAlpha = 0.001;
        // material.opacity = 0.1;
        // material.shadowSide = THREE.DoubleSide;
        // material.needsUpdate = true;
        // material.depthTest = false;

        // camera.position.x = laginter(domel.clientWidth, inter_points_ww);




        let composer


        renderer.domElement.style = ""

        let mixer;
        let clips;

        // Instantiate a loader
        const loader = new GLTFLoader();
        const x = require('@/assets/models/indev.glb');
        // Load a glTF resource
        loader.load(
            // resource URL
            x.default,
            // called when the resource is loaded
            function (gltf) {
                camera = gltf.cameras[0]
                const bloomPass = new UnrealBloomPass(new THREE.Vector2(domel.clientWidth, domel.clientHeight), 1.5, 0.4, 0.85);

                bloomPass.threshold = .5;
                bloomPass.strength = .3;
                bloomPass.radius = .8;

                const outputPass = new OutputPass();
                composer = new EffectComposer(renderer);
                composer.addPass(renderScene);
                const taaRenderPass = new TAARenderPass(scene, camera);
                taaRenderPass.unbiased = false;
                taaRenderPass.sampleLevel = 1;
                composer.addPass(taaRenderPass);
                composer.addPass(bloomPass);
                composer.addPass(outputPass);

                gltf.scene.getObjectByName( "Cube003_3" ).material = blinker_mat
                gltf.scene.getObjectByName( "Cube003_3" ).material.needsUpdate = true

                for (let index = 1; index <= 5; index++) {
                    gltf.scene.getObjectByName( `Effects${index}` ).material = index%2===0?effects_mat_1:effects_mat_2
                    gltf.scene.getObjectByName( `Effects${index}` ).material.needsUpdate = true
                }


                scene.add(gltf.scene);
                // const light = new THREE.AmbientLight(0xa0a0a0); // soft white light
                // scene.add(light);
                gltf.animations; // Array<THREE.AnimationClip>
                gltf.scene; // THREE.Group
                gltf.scenes; // Array<THREE.Group>
                gltf.cameras; // Array<THREE.Camera>
                gltf.asset; // Object

                camera.aspect = domel.clientWidth / domel.clientHeight;
                camera.updateProjectionMatrix();
                // camera.position.z = 20;
                // Create an AnimationMixer, and get the list of AnimationClip instances
                mixer = new THREE.AnimationMixer(gltf.scene);
                clips = gltf.animations;
                clips.forEach( function ( clip ) {
                    let a = mixer.clipAction( clip )
                    a.play();
                } );
                setTimeout(() => {
                    document.getElementById('indevbg').style.opacity = 1
                }, 500);

            },
            // called while loading is progressing
            function (xhr) {

            },
            // called when loading has errors
            function (error) {
                document.getElementById('innerpage').style.opacity = 1;
                document.body.style.overflowY = 'auto';
                console.log('An error happened');
                console.log(error)
            }
        );

        function animate(ctx) {
            if(!ctx.anim){
                return
            }
            requestAnimationFrame(()=>{
                animate(ctx)
            });

            // if(stats) {
            //     stats.update()
            // }
            const dt = CLOCK.getDelta();
            const canvas = renderer.domElement;
            const width = domel.clientWidth;
            const height = domel.clientHeight;
            const needResize = canvas.width !== width || canvas.height !== height;
            if (needResize) {
                renderer.setSize(width, height, false);
                composer.setSize(width, height, false);
                camera.aspect = domel.clientWidth / domel.clientHeight;
                // camera.position.x = laginter(domel.clientWidth, inter_points_ww);
                camera.updateProjectionMatrix();
            }

            uniforms['time'].value = performance.now() / 1000;

            // renderer.render( scene, camera );
            if(composer){
                composer.render();
            }
            if (mixer) {
                mixer.update(dt)
            }
        }
        animate(this);
    },
    unmounted(){
        this.anim = false
    }

}
</script>

<style>
    .indev-wrap{
        width: 100%;
        height: 90vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .indev-box{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    
    .indev-title{
        font-weight: 700;
        font-size: 2em;
        margin-bottom: 1em;
    }
    
    #indevbg{
        z-index: -5;
        position: absolute;
        left: 0;
        top:0;
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: opacity 6600ms cubic-bezier(0.165, 0.84, 0.44, 1);
    }
</style>